module.exports = __webpack_public_path__ + "img/analytics-bottom-banner.40cfef40.png";